import React, { useState, useEffect } from "react";
import { Upload, Modal, message, Typography, Image } from "antd";
import { get, isEqual, isNumber } from "lodash";
import { PlusOutlined } from "@ant-design/icons";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import instance from "../../../../store/api/instance";
import {
  getBucketUploadPayload,
  deleteUploadedFile,
} from "../../../../store/api/vendorHomeApi";
// import {
//   deleteProductAsset, getAllAtmedCatalogTourismStories
// } from '../../../../store/actions';
import documentsIcon from "../../../../assets/document.png";
import {
  deleteAtmedCatalogAbroadProcedurePhoto,
  getAllCatalogAbroadProcedure,
} from "../../../../store/actions";

const { Link } = Typography;

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

function PP(props) {
  const [previewVisible, setpreviewVisible] = useState(false);
  const [previewImage, setpreviewImage] = useState("");
  const [previewTitle, setpreviewTitle] = useState("");
  const [fileList, setFileList] = useState([]);
  useEffect(() => {
    const newFileList = (get(props.data, "photos") || []).map(
      (assetObj, index) => ({
        uid: assetObj.id,
        // name: `image${index}.png`,
        name: `${assetObj.url
          .split("/")
          .slice(-1)
          .join()
          .split(".")
          .shift()}. ${assetObj.url.split(".").pop()}`,
        // status: 'error',
        status: assetObj.status ? "success" : "error",
        //status: assetObj.status,
        url: assetObj.url,
        response: assetObj.status ? "Active" : "Pending",
      })
    );
    if (!isEqual(newFileList, fileList)) {
      setFileList(newFileList);
    }
  }, [props.data]);

  const handleCancel = () => setpreviewVisible(false);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setpreviewImage(file.url || file.preview);
    setpreviewVisible(true);
    setpreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };

  const handleChange = ({ fileLists }) => setFileList(fileLists);
  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );
  // get the S3 upload dpayload information
  const getUploadUrlPayload = async () => {
    const { data } = await getBucketUploadPayload(props.uploadBucketName);
    return data;
  };

  // returns the FormData for the upload request
  const getFormData = (file, payload) => {
    let filename = file.name.replace(/\s/g, "-").toLowerCase();
    const formData = new FormData();
    Object.keys(payload.fields).forEach((key) =>
      formData.append(key, payload.fields[key])
    );
    formData.append("file", file, filename);
    return formData;
  };
  // uploads the document to the S3 bucket
  const uploadDocument = async (url, formData, requestOptions) => {
    const { onSuccess, onError, onProgress } = requestOptions;

    // use onProgress to update Upload progress
    const config = {
      onUploadProgress: (event) => {
        onProgress({ percent: (event.loaded / event.total) * 100 });
      },
    };

    try {
      const res = await instance.post(url, formData, config);
      const uploadUrl = new DOMParser()
        .parseFromString(res.data, "application/xml")
        .getElementsByTagName("Location")[0].textContent;

      // use onSuccess to return the uploadUrl to the form value
      onSuccess(uploadUrl);
      props.addPhoto(decodeURIComponent(uploadUrl));
      setTimeout(
        () => props.getAllCatalogAbroadProcedure(undefined, 20, 1),
        500
      );
    } catch (err) {
      onError({ err });
    }
  };

  // file size validation
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isLt2M) {
      message.error("File upload must be less than 5MB!");
    }
    return isJpgOrPng && isLt2M;
  };
  // const onChange = (e) => {
  //   console.log("beforeUpload on Change", e.file);
  //   if (beforeUpload(e.file)) {
  //     props.onChange(e);
  //   }
  // };

  // defines a custom request for Upload
  const customRequest = async (requestOptions) => {
    const { file } = requestOptions;

    const uploadPayload = await getUploadUrlPayload(file);

    const { url } = uploadPayload;

    const formData = getFormData(file, uploadPayload);

    uploadDocument(url, formData, requestOptions);
  };
  const uploadProps = {
    accept: ".jpg,.png,.jpeg",
    beforeUpload,
    // onChange,
    customRequest,
    listType: "picture-card",
    fileList,
  };
  return (
    <Modal
      visible={props.visible}
      onCancel={props.onModalCancel}
      onOk={props.onOk}
      title={`${props.title}`}
      okText={props.submitText}
      destroyOnClose
      footer={null}
      {...props}
    >
      <Upload
        {...uploadProps}
        onPreview={(e) => handlePreview(e)}
        onChange={async ({ fileList: changedFileList, file }) => {
          if (isNumber(file.uid)) {
            await props.deleteAtmedCatalogAbroadProcedurePhoto({
              id: file.uid,
              abroad_procedure_id: props.data.id,
            });
            setTimeout(
              () => props.getAllCatalogAbroadProcedure(undefined, 20, 1),
              1000
            );
            deleteUploadedFile({
              s3: {
                url: file.url,
              },
            });
          }
          // if (file.size / 1024 / 1024 < 5 || file.size === undefined) {
          //   setFileList(changedFileList);
          // }
        }}
      >
        {fileList.length >= 12 ? null : uploadButton}
        {/* {uploadButton} */}
      </Upload>
      <Modal
        visible={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        {/* <img alt="NA" style={{ width: "100%" }} src={previewImage} /> */}
        {previewImage.match(/\.(pdf|doc|xls|xml)$/) != null ? (
          <Link href={previewImage} target="_blank">
            <Image
              preview={false}
              src={documentsIcon}
              style={{ marginRight: 6, width: "110px", height: "86px" }}
              alt="Route"
            />
          </Link>
        ) : (
          <img alt="NA" style={{ width: "100%" }} src={previewImage} />
        )}
      </Modal>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      deleteAtmedCatalogAbroadProcedurePhoto,
      getAllCatalogAbroadProcedure,
    },
    dispatch
  );

export default connect(() => {}, mapDispatchToProps)(PP);
